import React from 'react';
const ErrorMessage = ({ message }) =>
  message ? (
    <div className="add-edit-project-modal-error">
      <span>{message}</span>
    </div>
  ) : null;

export default ErrorMessage;
